// hooks/useAppSettings.ts
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { logAndThrow } from '../utils/logging';
import { normalizeDisciplinarySettings } from '../lib/disciplinary/leagueDisciplineSettings';

export const APP_SETTINGS_QUERY_KEY = ['appSettings'] as const;

export async function fetchActiveAppSettings() {
    const { data, error } = await supabase
        .from('app_settings_versions')
        .select('*')
        .eq('is_active', true)
        .maybeSingle();

    if (error) return logAndThrow('fetch app_settings_versions', error);

    // Same normalisation as the league-resolved settings (useLeagueDisciplinarySettings).
    const { settings: disciplinary_settings, isFallback } =
        normalizeDisciplinarySettings((data as any)?.disciplinary_settings);

    return {
        ...(data || {}),
        disciplinary_settings,
        disciplinary_settings_fallback: isFallback,
    } as any;
}

export const createAppSettingsQueryOptions = () => ({
    queryKey: APP_SETTINGS_QUERY_KEY,
    queryFn: fetchActiveAppSettings,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
});

export function useAppSettings() {
    return useQuery(createAppSettingsQueryOptions());
}